import React, { useState } from 'react'
import { connect } from "react-redux";
import { getUsers } from "../../store/actions";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import HistoryView from './history';
import EmailScheduleView from './email-schedule';
import './style.scss';

const EmailSetupView = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const handleTabSelect = (index) => {
    //if index is not a number, return. 
    // Because each change in the tab will trigger this function with the event object,
    // and event while typing in the input.
    if(typeof index !== 'number') return;

    setTabIndex(index);
  }

  return (
    <>
      <h2 className="page_title">Email Setup</h2>
      <Tabs selectedIndex={tabIndex} onSelect={handleTabSelect}>
        <div className="tabNav d-flex align-items-center justify-content-between">
          <TabList>
            <Tab>Email Schedule</Tab>
            <Tab>History</Tab>
          </TabList>
        </div>
        <div className="tabContent">
          <TabPanel>
            <EmailScheduleView />
          </TabPanel>
          <TabPanel>
            <HistoryView />
          </TabPanel>
        </div>
      </Tabs>
    </>
  )
}

const mapStateToProps = ({ UserReducer, UsersReducer }) => ({ UserReducer, UsersReducer });
export default connect(mapStateToProps, { getUsers, })(EmailSetupView);